import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './PayInput.scss';

class PayInput extends Component {
  constructor() {
    super();
    this.state = {
      password: '',
      passwordArr: new Array(6).fill(''),
      pwdError: false,
      regNum: /[^0-9]/g, //数字正则
    }
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    this.inputRef.current.focus();
  }

  passwordChange = (event) => {
    this.setState({
      password: event.target.value
    }, () => {
      if (this.state.password.length >= 6) {
        //this.inputRef.current.blur();
        this.props.pwdSureBack(this.state.password, true);
      } else {
        this.props.pwdSureBack('', false);
      }
    })
  }

  keyupEvent = (event) => {
    this.setState({
      password: event.target.value.replace(this.state.regNum, '')
    })
  }

  render () {
    return (
      <div className='payInput'>
        <label htmlFor="firstPwd">
          <ul>
            {
              this.state.passwordArr.map((item, index) => {
                return (
                  <li style={{ height: this.props.height, marginRight: this.props.marginRight }} key={index}>{this.state.password[index] ? <i></i> : ''}</li>
                )
              })
            }
          </ul>
        </label>
        <input id='firstPwd' maxLength="6" pattern="[0-9]*" type="tel" value={this.state.password} onChange={this.passwordChange.bind(this)} onKeyUp={this.keyupEvent.bind(this)} ref={this.inputRef} />
      </div>
    )
  }
}

PayInput.propTypes = {
  pwdSureBack: PropTypes.func.isRequired,
  height: PropTypes.string.isRequired,
  marginRight: PropTypes.string.isRequired,
  pwdError: PropTypes.bool
}

export default PayInput;